import React from 'react';
import { Reveal } from '../Reveal';
import { toolContrast } from '../../data/site';
export function Positioning() {
  return <section id="why" className="border-b border-line bg-cream" data-id="element-220" data-mp="159z1jguwqqn">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-221" data-mp="f6cng2vbqd4q">
        <p className="micro-label text-[9px] text-gold-600" data-id="element-222" data-mp="a6q9tsbl2uve">Why KeyTurn</p>

        <div className="mt-6 grid gap-y-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-end lg:gap-x-20" data-id="element-223" data-mp="a7j59x53dxy8">
          <h2 className="font-display text-[46px] font-semibold leading-[0.98] tracking-[-0.04em] text-charcoal-700 sm:text-[64px] lg:text-[76px]" data-id="element-224" data-mp="3ik6x2xupi9k3">
            Less project management.
            <br data-id="element-225" data-mp="3sefr5pzdyakd" />
            More opening.
          </h2>

          <div className="max-w-[52ch] lg:pb-2" data-id="element-226" data-mp="3nkl7gmjs5vla">
            <p className="text-[16px] leading-relaxed text-charcoal-500" data-id="element-227" data-mp="3njtab7ajbpsw">
              Hotel teams spend too much time managing the tools meant to manage the
              project - updating endless spreadsheets, fixing broken reporting formulas and feeding
              generic platforms that treat missing staples the same as a declined liquor licence.
            </p>
            <p className="mt-5 text-[16px] leading-relaxed text-charcoal-700" data-id="element-228" data-mp="uczwrb50bk9i">
              KeyTurn understands the difference. It works quietly in the background, surfaces what
              genuinely matters and tells the right people what needs attention next.
            </p>
          </div>
        </div>

        <Reveal className="mt-14 overflow-hidden rounded-2xl border border-line bg-white shadow-sm" data-id="element-229" data-mp="6iq97ome7e3s">
          <div className="grid grid-cols-1 border-b border-line sm:grid-cols-2" data-id="element-230" data-mp="bht3qf4qy1xi">
            <p className="micro-label border-b border-line px-6 py-3.5 text-[8.5px] text-charcoal-300 sm:border-b-0 sm:border-r sm:border-line" data-id="element-231" data-mp="gd8h75yudvte">
              A project-management tool
            </p>
            <p className="micro-label px-6 py-3.5 text-[8.5px] text-charcoal-700" data-id="element-232" data-mp="1rtfajmsh2pfu">KeyTurn</p>
          </div>

          <ul className="divide-y divide-line" data-id="element-233" data-mp="1vtqt8u19yfoo">
            {toolContrast.map(row => <li key={row.tool} className="grid grid-cols-1 sm:grid-cols-2" data-id="element-234" data-mp="3sud2pfy497ir">
                <p className="px-6 pb-2 pt-4 text-[14px] leading-snug text-charcoal-400 sm:border-r sm:border-line sm:py-5" data-id="element-235" data-mp="3nwbjmv0ox87a">
                  {row.tool}
                </p>
                <p className="px-6 pb-4 pt-0 text-[14px] font-medium leading-snug text-charcoal-700 sm:py-5" data-id="element-236" data-mp="rvropjurp4a">
                  {row.keyturn}
                </p>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}